import gql from 'graphql-tag';

import eventFragment from '~/shared/graphql-queries/events/event-fragment';

export default gql`
  mutation updateByIdEventMutation(
    $_id: MongoID!
    $record: UpdateByIdEventInput!
  ) {
    updateByIdEventMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...EventFragment
      }
      message
      title
    }
  }
  ${eventFragment}
`;
